<template>
    <div class="row">
        <div class="col-md-7">
            <label for="nome" class="control-label"
                >BUSCA POR NOME DAS CAIXAS CTO</label
            >
            <input id="nome" type="text" autocomplete="off" v-model="nome" class="form-control" />
        </div>

        <div class="col-md-5">
            <br />
            <blockquote class="blockquote-reverse">
                Total de CTOs: <b>{{ getContratos.length }}</b>
            </blockquote>
        </div>

        <div class="col-md-12" style="margin-top: 20px; margin-bottom: 20px; height: 300px; overflow: scroll">
            <table id="mytable" class="table table-bordred table-striped" >
                <thead>
                    <tr>
                        <th>NOME</th>
                        <th style="text-align: center;width: 140px">
                            PORTA PON
                        </th>
                        <th style="text-align: center;width: 120px">FIBRA</th>
                        <th style="text-align: center;width: 100px">VLAN</th>
                        <th style="text-align: center;width: 140px">AÇÕES</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="r in getContratos" v-bind:key="r._id">
                        <td>{{ r.nome }}</td>
                        <td class="text-center">{{ r.porta_pon.nome }}</td>
                        <td class="text-center">FO-{{ r.fibra.numero }}</td>
                        <td class="text-center">{{ r.vlan }}</td>
                        <td style="text-align: center">
                            <button @click="open(r._id)" type="button"
                                class="btn btn-primary btn-xs"
                            > Avançar
                                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { CaixasCTOMenu } from "../../components/exports";
import { CaixaCTO } from "../../class/index";

export default {
    components: {
        CaixasCTOMenu
    },
    data() {
        return {
            contratos: [],
            user: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome) {
                return this.contratos;
            }
            return this.contratos.filter(player => {
                return player.nome
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.load();
    },
    methods: {
        open(id) {
            this.$emit("clicked", id);
        },

        load() {
            CaixaCTO.all()
                .then(rows => (this.contratos = rows))
                .catch(err => console.log(err));
        }
    }
};
</script>

<style scoped></style>
